import { AssetType, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'asset_type_id';
export interface AssetTypeSearchParams extends SearchParams<Filter, Sort>, Partial<AssetType> {
  active?: boolean;
}

export const featurePath = '/v4/support/asset-type';

export const featureKeys = {
  all: [{ scope: 'asset-types' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: AssetTypeSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
